// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/awos-lwis-vgss-broadcasts.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/awos-lwis-vgss-broadcasts/awos-lwis-vgss-broadcasts.js';

mount([g0]);
